module.exports = __webpack_public_path__ + "static/media/Slide57.5f4dd207.JPG";